import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const lenis = window.lenisInstance;
  const blocks = document.querySelectorAll(".animated-hero");

  blocks.forEach((block) => {
    const mask = block.querySelector("[data-animated-hero-mask]");
    const pin = block.querySelector("[data-animated-hero-pin]");
    const trail = block.querySelector(".animated-hero-asset");
    const slides = Array.from(trail.children);
    const firstSlide = slides[0];
    const autoplay = block.dataset.autoplay === "true";

    //TODO: change the way we detect if the block is the front page
    const isFrontPage = block.classList.contains("is-front-page");
    const shouldStopScrollAndHideHeader = isFrontPage && window.scrollY <= 100;

    const videoControls = block.querySelector("[data-video-controls]");
    const scrollBadge = block.querySelector("[data-scroll-badge]");

    if (!mask || !pin || slides.length === 0) return;

    if (shouldStopScrollAndHideHeader) {
      window.hideHeader && window.hideHeader();
    }

    gsap.set(slides, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100dvh",
      opacity: 0,
    });

    // gsap.set(mask, { scale: 1.5 });
    gsap.set(firstSlide, { opacity: 1, zIndex: 1 });
    gsap.set([videoControls, scrollBadge], { opacity: 0 });

    const scrollTriggerOptions = {};
    if (isFrontPage) {
    } else {
      scrollTriggerOptions.pin = pin;
      if (autoplay) {
        scrollTriggerOptions.toggleActions = "play none none none";
        scrollTriggerOptions.scrub = false;
      } else {
        scrollTriggerOptions.scrub = 1;
      }
    }

    const mainTl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top top",
        end: "bottom top",
        ...scrollTriggerOptions,
      },
      onComplete: () => {
        if (isFrontPage && window.showHeader) {
          window.showHeader();
          // lenis?.start();
        }
      },
    });

    const tl1 = gsap.timeline();

    tl1.to(mask, {
      scale: 100,
      x: "150%",
      transformOrigin: "center",
      ease: "expo.in",
      duration: 1.5,
    });

    tl1.to(mask, { opacity: 0, zIndex: -1 });

    tl1.addLabel("Finish");

    const tl2 = gsap.timeline();

    slides.forEach((slide, index) => {
      const isFirst = index === 0;
      const isLast = index === slides.length - 1;
      const length = slides.length;

      const overlay = slide.querySelector(".wp-block-cover__background");
      const asset = slide.querySelector(".wp-block-cover__image-background");
      const innerContainer = slide.querySelector(
        ".wp-block-cover__inner-container"
      );

      // check if the inner-container has a video as child .wp-block-video

      const video = innerContainer.querySelector(".wp-block-video");

      tl2.addLabel("Start");

      if (!isFirst || length === 1) {
        tl2.to(
          slide,
          { opacity: 1, duration: 1, ease: "power2.inOut" },
          `slide-${index}`
        );
      }

      if (asset) {
        tl2.fromTo(
          asset,
          { scale: 1.15, ...(!isFirst && { filter: "blur(8px)" }) },
          { scale: 1, filter: "blur(0px)", duration: 1.2, ease: "expo.out" },
          `slide-${index}`
        );
      }

      if (overlay) {
        tl2.from(overlay, { opacity: 0 }, `slide-${index}`);
      }

      if (innerContainer && !video && !isLast) {
        tl2.from(
          innerContainer,
          { opacity: 0, y: 50, ease: "expo.out", duration: 0.5 },
          `slide-${index}+=0.5`
        );
      }
    });

    // TODO: change the way we detect if the block is the front page
    if (isFrontPage) {
      tl1.to(scrollBadge, { opacity: 1, duration: 0.5 }, "Finish");
      const videos = block.querySelectorAll("video");
      // Manage the play or pause event for all the videos in the block

      if (videos.length > 0) {
        tl1.to(videoControls, { opacity: 1, duration: 0.5 }, "Finish");
        const volumeBtn = videoControls.querySelector("[data-video-volume]");
        const playBtn = videoControls.querySelector("[data-video-playback]");

        playBtn.addEventListener("click", () => {
          videos.forEach((video) => {
            // Toggle .active class
            playBtn.classList.toggle("active");
            video.paused ? video.play() : video.pause();
          });
        });
        // Manage the volume event for all the videos in the block
        volumeBtn.addEventListener("click", () => {
          videos.forEach((video) => {
            volumeBtn.classList.toggle("active");
            video.muted = !video.muted;
            video.volume = video.muted ? 0 : 1;
          });
        });
      }
    }

    mainTl.add(tl1);
    mainTl.add(tl2);

    if (isFrontPage) {
      mainTl.progress(0).pause();
      window.document.addEventListener("onAgeVerified", () => {
        console.log("Age verified event triggered");
        mainTl.play();
      });
    }
  });
});
